import raw from './free_email_provider_domains.txt';
import * as EmailValidator from 'email-validator';

class CompanyEmailValidator {
    constructor() {
        (async () => {

            // All async code here
            let r = await fetch(raw);
            this.text = await r.text();

            // console.log('text decoded:', this.text);
            this.free_provider_set = new Set(this.text.split("\n"));

            return this; // when done
        })()
        // fetch(raw)
        //     .then(r => r.text())
        //     .then(text => {
        //         console.log('text decoded:', text);
        //     });
    }

    isCompanyEmail(email) {
        // 1. first, check if it's a valid email
        if (!EmailValidator.validate(email)) {
            return false; // it's not a company email address because it's not valid
        }
        // 2. check if it's a company email
        let fields = email.split('@');
        let domain = fields[1];
        return !this.free_provider_set.has(domain); // if the free provider set doesn't have this domain, then most likely it's a company email address
    }
}

export default CompanyEmailValidator;